<template>
	<div>
		<div class="lg:flex">
			<div class="lg:w-1/2 flex"></div>
			<div class="lg:w-1/2 flex justify-end">
				<ButtonBlack>
					<router-link
						:to="'/admin/' + section"
						class="text-white no-underline"
					>
						<div class="flex items-center">
							<img src="@/assets/img/nuevo-mas.svg" alt="Nuevo" />
							<span>{{ $t('new') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
			</div>
		</div>
		<ListTable
			:itemsTitles="itemsTitles"
			:items="banners"
			:section="section"
			:itemsTable="itemsTable"
		/>
	</div>
</template>

<script>
import ListTable from '@/components/ListTable'
import gql from 'graphql-tag'

export default {
	apollo: {
		banners: {
			query: gql`
				{
					banners(order_by: { publishing_date: desc }) {
						id
						banner_name
						country {
							code
						}
						order
						publishing_date
						active
					}
				}
			`,
			update(data) {
				return data.banners.map(item => ({
					id: item.id,
					name: item.banner_name,
					countryCode: item.country.code,
					order: item.order,
					date: this.$moment(item.publishing_date).format('DD-MM-YYYY'),
					edit: true,
					active: item.active
				}))
			}
		}
	},
	data() {
		return {
			section: 'banners',
			itemsTable: 'banners',
			itemsTitles: ['Id', 'Nombre', 'Pais', 'Orden', 'date']
		}
	},
	components: {
		ListTable
	}
}
</script>
